import GoodAndRetunsTransferController from 'pages/Controller/GoodAndRetunsTransferController';
import React from 'react';
import { Box, Card, TextField, Button, Typography } from '@mui/material';
import Loader from 'utils/Loader';

function GoodAndReturnsTransfer() {
  const {
    loader,
    party,
    LRNumber,
    setLRNumber,
    LRDate,
    setLRDate,
    Transporter,
    setTransporter,
    eWayBill,
    setEWayBill,
    discountPercentage,
    setDiscountPercentage,

    lrCopyFile,
    setLRCopyFile,
    debitNoteFile,
    setDebitNoteFile,

    handleClearButtonClick,
    handleSubmit,
    errors,
  } = GoodAndRetunsTransferController();


  return (
    <div
      className="bg"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px 16px',
      }}
    >
      <div className="cutrange" style={{ width: '100%', maxWidth: 900 }}>
        <span className="font20">GOOD RETURNS TRANSFER</span>
      </div>

      {loader ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Fetching...</span>
        </div>
      ) : null}

      <Card sx={{ width: '100%', maxWidth: 900, marginTop: 3, p: 3 }}>
        {loader && (
          <div
            style={{
              position: 'absolute',   // ✅ change from fixed
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(255,255,255,0.7)',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <Loader />
            <span style={{ marginTop: '10px' }}>Fetching...</span>
          </div>
        )}

        <Typography variant="h4" gutterBottom>
          {party?.label}
        </Typography>


        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
            <TextField
              label="LR Number"
              value={LRNumber}
              onChange={(e) => setLRNumber(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              error={!!errors.LRNumber}
              helperText={errors.LRNumber}
            />
            <TextField
              label="LR Date"
              type="date"
              value={LRDate}
              onChange={(e) => setLRDate(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              InputLabelProps={{ shrink: true }}
              error={!!errors.LRDate}
              helperText={errors.LRDate}
            />
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
            <TextField
              label="Transporter"
              value={Transporter}
              onChange={(e) => setTransporter(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              error={!!errors.Transporter}
              helperText={errors.Transporter}
            />
            <TextField
              label="E-Way Bill Number"
              value={eWayBill}
              onChange={(e) => setEWayBill(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              error={!!errors.eWayBill}
              helperText={errors.eWayBill}
            />
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
            <TextField
              label="Discount Percentage"
              value={discountPercentage}
              onChange={(e) => setDiscountPercentage(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              error={!!errors.discountPercentage}
              helperText={errors.discountPercentage}
            />
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
            <Box>
              <Button variant="outlined" component="label" fullWidth>
                LR Copy
                <input
                  hidden
                  accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                  type="file"
                  onChange={(e) => setLRCopyFile(e.target.files && e.target.files[0])}
                />
              </Button>
              {errors.lrCopyFile && (
                <Typography variant="caption" color="error">
                  {errors.lrCopyFile}
                </Typography>
              )}
            </Box>
            <Box>
              <Button variant="outlined" component="label" fullWidth>
                Debit Note Copy
                <input
                  hidden
                  accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                  type="file"
                  onChange={(e) => setDebitNoteFile(e.target.files && e.target.files[0])}
                />
              </Button>
              {errors.debitNoteFile && (
                <Typography variant="caption" color="error">
                  {errors.debitNoteFile}
                </Typography>
              )}
            </Box>
          </Box>
          <Box>
            <div style={{ fontSize: 13, color: '#444' }}>
              {lrCopyFile ? `LR Copy: ${lrCopyFile.name}` : 'No LR Copy selected'}
            </div>
            <div style={{ fontSize: 13, color: '#444' }}>
              {debitNoteFile ? `Debit Note: ${debitNoteFile.name}` : 'No Debit Note selected'}
            </div>
          </Box>
        </Box>
      </Card>

      <div className="footer-button" style={{ marginTop: 20 }}>
        <button onClick={handleClearButtonClick} style={{ marginRight: '15px' }}>
          {'Clear'}
        </button>
        <button style={{ marginRight: '15px' }}
          onClick={handleSubmit}
        >
          {'Submit'}
        </button>
      </div>

    </div>
  );
}

export default GoodAndReturnsTransfer;
